<template>
  <b-row>
    <b-col cols="12">
      <filter-params :get-filtered-data="getFilteredData" />
    </b-col>
    <b-col
      cols="12"
      md="3"
    >
      <counter-card
        title-text="Kategoriler"
        :value-text="dashboard.categoryCount | toNumber"
        color-variant="info"
        icon-name="FolderIcon"
      />
      <counter-card
        title-text="Ürünler"
        :value-text="dashboard.productCount | toNumber"
        color-variant="success"
        icon-name="CoffeeIcon"
      />
      <counter-card
        title-text="Bağlantılar"
        :value-text="dashboard.qrCount | toNumber"
        color-variant="warning"
        icon-name="LinkIcon"
      />
      <counter-card
        title-text="Şubeler"
        :value-text="dashboard.branchCount | toNumber"
        color-variant="secondary"
        icon-name="HomeIcon"
      />
      <counter-card
        title-text="Görseller"
        :value-text="dashboard.imageCount | toNumber"
        color-variant="danger"
        icon-name="ImageIcon"
      />
      <b-card
        title="Disk Kullanımı"
      >
        <disk-usage :data-item="dashboard.diskUsage" />
      </b-card>
    </b-col>
    <b-col
      cols="12"
      md="9"
    >
      <b-card title="İstatistikler">
        <div class="mb-2">
          <visit-card :data-item="dashboard.visits" />
        </div>
        <div class="mb-2">
          <rating-card :data-item="dashboard.ratingAvg" />
        </div>
      </b-card>
      <most-viewed-card :data-list="dashboard.mostViewed" />
      <qr-visits-card :data-list="dashboard.qrVisits" />
    </b-col>
  </b-row>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import CounterCard from '@/views/Reports/components/CounterCard.vue'
import RatingCard from '@/views/Reports/components/RatingCard.vue'
import DiskUsage from '@/views/Reports/components/DiskUsage.vue'
import VisitCard from '@/views/Reports/components/VisitCard.vue'
import MostViewedCard from '@/views/Reports/components/MostViewedCard.vue'
import QrVisitsCard from '@/views/Reports/components/QrVisitsCard.vue'
import FilterParams from '@/views/Reports/components/FilterParams.vue'

export default {
  name: 'ReportIndex',
  components: {
    BCard,
    BRow,
    BCol,
    CounterCard,
    RatingCard,
    DiskUsage,
    VisitCard,
    MostViewedCard,
    QrVisitsCard,
    FilterParams,
  },
  computed: {
    dashboard() {
      return this.$store.getters['reports/dashboard']
    },
    filterParams() {
      return this.$store.getters['reports/filterParams']
    },
  },
  created() {
    this.process()
  },
  methods: {
    process() {
      this.getData('ratingAvg')
      this.getData('diskUsage')
      this.getData('imageCount')
      this.getData('productCount')
      this.getData('categoryCount')
      this.getData('qrCount')
      this.getData('branchCount')
      this.getData('visits')
      this.getData('qrVisits')
      this.getData('mostViewed')
    },
    getFilteredData() {
      this.getData('ratingAvg')
      this.getData('diskUsage')
      this.getData('imageCount')
      this.getData('productCount')
      this.getData('categoryCount')
      this.getData('qrCount')
      this.getData('branchCount')
      this.getData('visits')
      this.getData('qrVisits')
      this.getData('mostViewed')
    },
    getData(type) {
      this.$store.dispatch('reports/getDashboard', {
        type,
        sdate: this.filterParams.sdate,
        edate: this.filterParams.edate,
        id_branches: this.filterParams.id_branches,
      })
    },
  },
}
</script>
